import React from 'react';
import { ProgressBar } from 'shared/ProgressBar';
import { Button } from 'shared/Button/NewButton';
import { CheckmarkCircleIcon } from 'shared/Icon/components/CheckmarkCircleIcon';
import { useT } from 'client/i18n/hooks/useT';
import {
  getStatusHeading,
  getStatusLabel,
} from 'screens/EpisodeOptionsScreen/components/EpisodeContent/UploadingState/utils';
import {
  ContentWrapper,
  uploaderCancelButtonStyle,
  UploaderContainer,
  UploaderContentsContainer,
  uploaderRetryButtonStyle,
  UploaderStatusContainer,
  UploaderStatusHeading,
  UploaderStatusLabel,
} from '../styles';
import { IconWrapper } from './styles';

type UploadingStateProps = {
  percentageComplete?: number;
  onCancelUpload?: () => void;
  onRetryUpload?: () => void;
  onCancelProcessing?: () => void;
  isUploading?: boolean;
  isProcessing?: boolean;
  isError?: boolean;
};

export const UploadingState = ({
  percentageComplete = 100,
  onCancelUpload,
  onRetryUpload,
  onCancelProcessing,
  isUploading,
  isProcessing,
  isError,
}: UploadingStateProps) => {
  const t = useT();

  return (
    <ContentWrapper>
      <UploaderContainer>
        <UploaderContentsContainer>
          <UploaderStatusHeading>
            {getStatusHeading(t, isProcessing, isError, percentageComplete)}
          </UploaderStatusHeading>
          <UploaderStatusLabel>
            {getStatusLabel(t, isProcessing, isError, percentageComplete)}
          </UploaderStatusLabel>
        </UploaderContentsContainer>
        <UploaderStatusContainer>
          {isUploading && percentageComplete < 100 && (
            <Button
              color="white"
              className={uploaderCancelButtonStyle}
              onClick={onCancelUpload}
            >
              {t('Button.Cancel', 'Cancel', 'Cancel button text')}
            </Button>
          )}
          {isError && isProcessing && (
            <Button
              color="white"
              className={uploaderCancelButtonStyle}
              onClick={onCancelProcessing}
            >
              {t('Button.Cancel', 'Cancel', 'Cancel button text')}
            </Button>
          )}
          {isError && !isProcessing && (
            <Button
              color="white"
              className={uploaderRetryButtonStyle}
              onClick={onRetryUpload}
            >
              {t('Button.Retry', 'Retry', 'Retry button text')}
            </Button>
          )}
          {isUploading && percentageComplete === 100 && (
            <IconWrapper>
              <CheckmarkCircleIcon />
            </IconWrapper>
          )}
        </UploaderStatusContainer>
      </UploaderContainer>
      <ProgressBar percentage={percentageComplete} height={4} />
    </ContentWrapper>
  );
};
